var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumSirDeClame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 78,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9077 41.1193C19.294 41.1193 18.7486 41.0142 18.2713 40.804C17.7969 40.5937 17.4219 40.3011 17.1463 39.9261C16.8707 39.5511 16.7244 39.1179 16.7074 38.6264H18.3097C18.3239 38.8622 18.402 39.0682 18.544 39.2443C18.6861 39.4176 18.875 39.5526 19.1108 39.6491C19.3466 39.7457 19.6108 39.794 19.9034 39.794C20.2159 39.794 20.4929 39.7401 20.7344 39.6321C20.9759 39.5213 21.1648 39.3679 21.3011 39.1719C21.4375 38.9759 21.5043 38.75 21.5014 38.4943C21.5043 38.2301 21.4361 37.9972 21.2969 37.7955C21.1577 37.5937 20.956 37.4361 20.6918 37.3224C20.4304 37.2088 20.1151 37.152 19.7457 37.152H18.9744V35.9332H19.7457C20.0497 35.9332 20.3153 35.8807 20.5426 35.7756C20.7727 35.6705 20.9531 35.5227 21.0838 35.3324C21.2145 35.1392 21.2784 34.9162 21.2756 34.6634C21.2784 34.4162 21.223 34.2017 21.1094 34.0199C20.9986 33.8352 20.8409 33.6918 20.6364 33.5895C20.4347 33.4872 20.1974 33.4361 19.9247 33.4361C19.6577 33.4361 19.4105 33.4844 19.1832 33.581C18.956 33.6776 18.7727 33.8153 18.6335 33.9943C18.4943 34.1705 18.4205 34.3807 18.4119 34.625H16.8906C16.902 34.1364 17.0426 33.7074 17.3125 33.3381C17.5852 32.9659 17.9489 32.6761 18.4034 32.4688C18.858 32.2585 19.3679 32.1534 19.9332 32.1534C20.5156 32.1534 21.0213 32.2628 21.4503 32.4815C21.8821 32.6974 22.2159 32.9886 22.4517 33.3551C22.6875 33.7216 22.8054 34.1264 22.8054 34.5696C22.8082 35.0611 22.6634 35.473 22.3707 35.8054C22.081 36.1378 21.7003 36.3551 21.2287 36.4574V36.5256C21.8423 36.6108 22.3125 36.8381 22.6392 37.2074C22.9688 37.5739 23.1321 38.0298 23.1293 38.5753C23.1293 39.0639 22.9901 39.5014 22.7116 39.8878C22.4361 40.2713 22.0554 40.5724 21.5696 40.7912C21.0866 41.0099 20.5327 41.1193 19.9077 41.1193Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 1,
    width: 37,
    height: 78,
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6179 39.3807V38.1236L57.321 32.2727H58.3693V34.0625H57.7301L55.2372 38.0128V38.081H60.4062V39.3807H53.6179ZM57.7812 41V38.9972L57.7983 38.4347V32.2727H59.2898V41H57.7812Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumSirDeClame2);
export default __webpack_public_path__ + "static/media/jum_sir_de_clame_2.14b92349ef46cf3b98d3d505f3f96749.svg";
export { ForwardRef as ReactComponent };